var cov_2bm2w4jbrx = function () {
  var path = "/Users/spana/SHEIN/shineout/src/AnimationList/styles/index.ts",
      hash = "dee5a0a6c2fc8e1b8fc054fe673624c720039a86",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/AnimationList/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


import genaration from '../../utils/classname';
var listLess = {};
export var listClass = (cov_2bm2w4jbrx.s[0]++, genaration(listLess, 'list'));